// src/Components/Admin/AdminPanelLayout.jsx
import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./AdminPanelLayout.css"; 
import Logo from "../../Assets/images/logo-rmbg.png";
import { logout } from "../../../utils/logout";

import DashboardIcon from "../../Assets/icons/dashboard.png";
import LogoutIcon from "../../Assets/icons/logout.png";
import PasswirdIcon from "../../Assets/icons/change-password.png";
import SystemLogsIcon from "../../Assets/icons/logs.png";

import CurrentIcon from "../../Assets/icons/current.png";
import PendingIcon from "../../Assets/icons/pending.png";
import RejectedIcon from "../../Assets/icons/rejected.png";
import ManageIcon from "../../Assets/icons/manage.png";
import TalentIcon from "../../Assets/icons/talent.png";
import UsersIcon from "../../Assets/icons/users.png";


import { FaBars, FaTimes } from "react-icons/fa";

const AdminPanelLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="admin-grid-container">
      {/* Top Navbar */}
      <div className="top-navbar">
        <div className="navbar-toggle">
          {isSidebarOpen ? (
            <FaTimes
              className="menu-toggle"
              onClick={toggleSidebar}
              aria-label="Close menu"
            />
          ) : (
            <FaBars
              className="menu-toggle"
              onClick={toggleSidebar}
              aria-label="Open menu"
            />
          )}
        </div>
        <div className="navbar-title">UGAA Liberia Admin Panel</div>
      </div>

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar}></div>
      )}

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <img src={Logo} alt="Logo" className="sidebar-logo" />
        <nav className="sidebar-nav">
          <NavLink
            to="/admin-panel/dashboard"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeSidebar}
          >
            <img src={DashboardIcon} alt="Dashboard" className="nav-img" /> Dashboard
          </NavLink>

        
          <NavLink
            to="/admin-panel/current-members"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeSidebar}
          >
            <img src={CurrentIcon} alt="Dashboard" className="nav-img" /> Current Members
          </NavLink>

          <NavLink to="/admin-panel/pending-registrations"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeSidebar}
          >
            <img src={PendingIcon} alt="Dashboard" className="nav-img" /> Pending Registrations
          </NavLink>

          <NavLink
            to="/admin-panel/manage-alumni"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeSidebar}
          >
            <img src={ManageIcon} alt="Dashboard" className="nav-img" /> Manage Alumni
          </NavLink>

          <NavLink to="/admin-panel/rejected-registrations"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeSidebar}
          >
            <img src={RejectedIcon} alt="Dashboard" className="nav-img" /> Rejected Registrations
          </NavLink>

          <NavLink
            to="/admin-panel/users"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeSidebar}
          >
            <img src={UsersIcon} alt="Dashboard" className="nav-img" /> System Users
          </NavLink>


          <NavLink
            to="/admin-panel/change-password"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeSidebar}
          >
            <img src={PasswirdIcon} alt="PasswirdIcon" className="nav-img" /> Change Password
          </NavLink>

          <NavLink
            to="/admin-panel/logs"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeSidebar}
          >
            <img src={SystemLogsIcon} alt="SystemLogsIcon" className="nav-img" /> System Logs
          </NavLink>

          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => {
              closeSidebar();
              logout();
            }}
          >
            <img src={LogoutIcon} alt="Logout" className="nav-img" /> Logout
          </NavLink>
        </nav>
      </div>

      {/* Main Content Area */}
      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminPanelLayout;
